"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.storages = void 0;
var qs_1 = require("qs");
var storageUrl = '/storage';
exports.storages = function (axios) {
    var _baseURL = axios.defaults.baseURL;
    return {
        getStorageContracts: function (request) {
            request.responseType = 'arraybuffer';
            if (axios.storageApiUrl) {
                var baseURL_1 = axios.defaults.baseURL;
                axios.defaults.baseURL = axios.storageApiUrl;
                return axios.get('/contracts', request).then(function (res) {
                    return res;
                }).finally(function () {
                    axios.defaults.baseURL = baseURL_1;
                });
            }
            return axios.get('/contracts', request);
        },
        postStorageContracts: function (request) {
            var _a;
            if (axios.storageApiUrl) {
                var baseURL_2 = axios.defaults.baseURL;
                axios.defaults.baseURL = axios.storageApiUrl;
                var url = (request === null || request === void 0 ? void 0 : request.params) ? "/contracts?contractNo=" + ((_a = request === null || request === void 0 ? void 0 : request.params) === null || _a === void 0 ? void 0 : _a.contractNo) : '/contracts';
                return axios.post(url, request.data).then(function (res) {
                    return res;
                }).finally(function () {
                    axios.defaults.baseURL = baseURL_2;
                });
            }
            return axios.post('/contracts', request.data);
        },
        postImages: function (postImagesRequest) {
            if (axios.storageApiUrl) {
                axios.defaults.baseURL = axios.storageApiUrl;
                return axios.post("/images?mallNo=" + postImagesRequest.params.mallNo + "&overwrite=" + postImagesRequest.params.overwrite, postImagesRequest.data).then(function (res) {
                    return res;
                }).finally(function () {
                    axios.defaults.baseURL = _baseURL;
                });
            }
            return axios.post("/images?mallNo=" + postImagesRequest.params.mallNo, postImagesRequest.data);
        },
        deleteImages: function (request) {
            var query = qs_1.stringify(request.params);
            if (axios.storageApiUrl) {
                var baseURL = axios.defaults.baseURL;
                axios.defaults.baseURL = axios.storageApiUrl;
                var response = axios.delete("/images?" + query);
                axios.defaults.baseURL = baseURL;
                return response;
            }
            return axios.delete("/images?" + query);
        },
        getStorage: function (getStorageRequest) {
            if (axios.storageApiUrl) {
                var baseURL_3 = axios.defaults.baseURL;
                axios.defaults.baseURL = axios.storageApiUrl;
                return axios.get(storageUrl, getStorageRequest).then(function (res) {
                    return res;
                }).finally(function () {
                    axios.defaults.baseURL = baseURL_3;
                });
            }
            return axios.get(storageUrl, getStorageRequest);
        },
        postStorage: function (postStorageRequest) {
            if (axios.storageApiUrl) {
                var baseURL = axios.defaults.baseURL;
                axios.defaults.baseURL = axios.storageApiUrl;
                var response = axios.post(storageUrl, postStorageRequest.data);
                axios.defaults.baseURL = baseURL;
                return response;
            }
            return axios.post("" + storageUrl, postStorageRequest.data);
        },
        deleteStorage: function (request) {
            var query = qs_1.stringify(request.params);
            if (axios.storageApiUrl) {
                var baseURL = axios.defaults.baseURL;
                axios.defaults.baseURL = axios.storageApiUrl;
                var response = axios.delete("/storage?" + query);
                axios.defaults.baseURL = baseURL;
                return response;
            }
            return axios.delete("/storage?" + query);
        }
    };
};
